// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostExcelForAdminRequestModel from '../../model/post-excel-for-admin-request-model';
import PostExcelForAdminRequestDTO from '../dto/post-excel-for-admin-request-dto';
import dtoSchema from '../schemas/post-excel-for-admin-request-schema';
import ApiPagingRequestModel from '../../model/api-paging-request-model';

export default abstract class PostExcelForAdminRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostExcelForAdminRequestDTO>) {
    super();
    if (data) {
      this.id = data.id ?? undefined;
      this.key = data.key ?? undefined;
      this.searchCriteria = data.searchCriteria ?? undefined;
      this.paging = data.paging ? ApiPagingRequestModel.toModel(data.paging) : undefined;
      this.selectedOrganisationId = data.selectedOrganisationId ?? undefined;
      this.selectedEventId = data.selectedEventId ?? undefined;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;
  /**
  */
  paging?: ApiPagingRequestModel;
  /**
  * @type {int64}
  */
  selectedOrganisationId?: number;
  /**
  * @type {int64}
  */
  selectedEventId?: number;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<PostExcelForAdminRequestDTO>): PostExcelForAdminRequestModel;
  static toModel(dto: DeepPartial<PostExcelForAdminRequestDTO> | undefined | null): PostExcelForAdminRequestModel | undefined;
  static toModel(dto: DeepPartial<PostExcelForAdminRequestDTO> | undefined | null): PostExcelForAdminRequestModel | undefined {
    return dto ? new PostExcelForAdminRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostExcelForAdminRequestModel> | PostExcelForAdminRequestModel): PostExcelForAdminRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
      paging: unwrapped.paging,
      selectedOrganisationId: unwrapped.selectedOrganisationId,
      selectedEventId: unwrapped.selectedEventId,
      eventIdentifier: unwrapped.eventIdentifier,
    } as PostExcelForAdminRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostExcelForAdminRequestModel, can not map to PostExcelForAdminRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
